import { Box, Divider, Paper, Stack, Typography } from "@mui/material";

interface IPanelProps extends React.PropsWithChildren {
    title: string;
    actions?: React.ReactNode;
}

export const Panel = (props: IPanelProps) => {
    const { title, actions, children } = props;

    return (
        <Paper variant="outlined" sx={{ p: 0, overflow: "hidden" }}>
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                p={2}
                sx={{
                    bgcolor: (theme) => theme.palette.primary.main,
                }}
            >
                <Typography fontWeight={600} color="primary.contrastText">
                    {title}
                </Typography>

                <Stack direction={"row"} gap={2}>
                    {actions}
                </Stack>
            </Stack>

            <Divider />

            <Box p={2}>{children}</Box>
        </Paper>
    );
};
